module.exports = __webpack_public_path__ + "img/User.6613c0db.svg";